import React from "react";
import { Route, Routes } from "react-router-dom";
import QuizAddPage from "./QuizAddPage";
import QuizListPage from "./QuizListPage";

const QuizPage = () => {
  return (
    <>
      <Routes>
        <Route index element={<QuizListPage />} />
        <Route path="add/:lecture_id" element={<QuizAddPage />} />
        <Route path="update/:qid" element={<QuizAddPage />} />
      </Routes>
    </>
  );
};

export default QuizPage;
